import React from 'react';
import { Theme, Typography, Button } from '@mui/material';
import { createStyles, WithStyles, withStyles } from '@mui/styles';
import { ButtonProps } from '@mui/material/Button';
import { WithTranslation, withTranslation } from 'react-i18next';

import { PrevIcon } from 'assets/icons';

interface PrevButtonProps extends WithStyles<typeof styles>, WithTranslation {
    buttonProps?: ButtonProps;
    title?: string;
}

const styles = (theme: Theme) =>
    createStyles({
        root: {
            height: '88px',
            minWidth: '360px',
        },
        icon: {
            marginRight: '92px',
        },
        label: {
            marginRight: '55px',
        },
    });

class PrevButton extends React.Component<PrevButtonProps, any> {
    render() {
        const { classes, t, title, buttonProps } = this.props;

        return (
            <Button
                classes={{
                    startIcon: classes.icon,
                    root: classes.root,
                }}
                startIcon={<PrevIcon colorType='secondary' />}
                variant='secondary'
                {...buttonProps}
            >
                <Typography className={classes.label} variant='button'>
                    {title || t('Back')}
                </Typography>
            </Button>
        );
    }
}

export default withTranslation()(withStyles(styles)(PrevButton));
